import React, {useContext, useEffect} from 'react'
import {Form, InputNumber} from "antd";
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const OfferUpdateDiscount2 = ({rowIndex, record}) => {

    const [form] = Form.useForm()
    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    useEffect(() => {
        if (record) {
            form.setFieldsValue({
                [`updateDiscount2-${rowIndex}`]: record.discount2 || 0
            })
        }
    }, [rowIndex, record])

    const handleDiscountChange = ({target}) => {
        const generateList = replaceIndexAt(
            bidList,
            {
                ...record,
                discount2: target.value
            },
            rowIndex
        )
        setBidList(generateList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={`updateDiscount2-${rowIndex}`}>
                    <InputNumber
                        min={0} max={100} step={0.1} onBlur={handleDiscountChange} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateDiscount2